import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { PlantService, GlobalRegionService } from '../../../mesc.service';
import { Plant } from '../../../../../shared/model';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { MaintenanceService } from "../maintenance.service";


@Component({
  selector: 'mesc-plants',
  templateUrl: './plants.component.html',
  // styleUrls: ['./Plants.component.scss']
})
export class PlantsComponent implements OnInit {
  private readonly maintenanceService: MaintenanceService;

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;

  constructor(
    private service: PlantService,
    private GlobalRegion: GlobalRegionService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private readonly injector: Injector,
  ) { 
    this.maintenanceService = injector.get(MaintenanceService);
    this.maintenanceService.getCurrentPageValue();
  }
  
  isNew: boolean = false;
  editDataItem: Plant;
  editForm = new FormGroup({
    Id: new FormControl(),
    PlantDescription: new FormControl("", Validators.required),
    PlantCode: new FormControl("", Validators.required),
    IsActive: new FormControl(false, Validators.required),
    GlobalRegionId: new FormControl("", Validators.required),
    CreatedBy: new FormControl(),
    CreatedDate: new FormControl(),
  });

  columns: any[] = [
    {
      field: "PlantDescription",
      title: "Plant Description",
    },
    {
      field: "PlantCode",
      title: "Plant Code",
    },
    {
      field: 'GlobalRegionName',
      title: 'Global Region',
    },
    {
      field: "IsActive",
      title: "Status",
      width: "125",
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    }
  ];

  onSave = (dataItem, isNew) => {
    var self = this;
    self.service.save(dataItem, isNew, "", true, false)
      .then(function () {
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });
      }).catch(function (response) {
        self.service.loading.next(false);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      });
  }

  onRead = () => {
    return this.service.read('', true);
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true
    },
    columns: this.columns,
    service: this.service,
    save: this.onSave,
    read: this.onRead,
    fileName: 'plants.xlsx'
  }

  formDialog = {
    title: "Plant",
    formControls: [
      {
        type: "text",
        name: "PlantDescription",
        title: "Plant Description*",
        readonly: "never",
      },
      {
        type: "text",
        name: "PlantCode",
        title: "Plant Code*",
        readonly: "never",
      },
      {
        type: "combobox",
        readonly: "never",
        name: "GlobalRegionId",
        title: "Global Region*",
        textField: 'Description',
        valueField: 'Id',
        placeholder: 'Select Global Region...',
        service: this.GlobalRegion,
      },
      {
        type: "boolean",
        name: "IsActive",
        title: "Active"
      }
    ],
  }

  ngOnInit(): void {
    this.GlobalRegion.query();
  }

  setModelHandler() {
    this.editDataItem = new Plant();
    this.editDataItem.IsActive = true;
  }
}